import type { RouteObject } from 'react-router';
import { ModuleRoute } from '@/components/guards';

/** Rotas deste módulo, montadas dentro do layout do painel (caminhos relativos). */
export const inboxRoutes: RouteObject[] = [
  {
    path: 'atendimento',
    element: <ModuleRoute module="inbox" permission="inbox:read" />,
    children: [
      { path: 'configuracao', lazy: async () => ({ Component: (await import('./settings')).InboxSettingsPage }) },
      // Uma rota só para a lista e a conversa: trocar de conversa não remonta a lista.
      { path: ':id?', lazy: async () => ({ Component: (await import('./inbox')).InboxPage }) },
    ],
  },
];
